export default __webpack_public_path__ + "static/media/511.adc41f30.gif";